<template>
  <div v-if="viewAllowed">
    <portal to="top-bar-right">
      <YButton class="btn btn-blue" @click="addTemplateImage"
        >Add New Image</YButton
      >
    </portal>
    <TemplateImagesTableWrapper></TemplateImagesTableWrapper>
  </div>
</template>

<script>
import TemplateImagesTableWrapper from '@/views/Admin/TemplateImages/TemplateImagesTableWrapper'
import AddTemplateImage from '@/views/Admin/TemplateImages/AddTemplateImage.vue'
import ME_QUERY from '@/graphql/User/MeQuery.gql'

export default {
  apollo: {
    me: {
      query: ME_QUERY,
      result({ data }) {
        if (data && data.me) {
          this.me = data.me
        }
      }
    }
  },
  computed: {
    viewAllowed() {
      if (
        this.me &&
        this.me.roles &&
        this.me.roles.some(role => role.name !== 'sales-admin-level-1')
      ) {
        return true
      }

      return false
    }
  },
  props: {},
  components: {
    TemplateImagesTableWrapper
  },

  methods: {
    addTemplateImage() {
      this.$modal.show(
        AddTemplateImage,
        {},
        {
          height: 'auto',
          width: '80%',
          maxWidth: 600,
          adaptive: true,
          scrollable: true
        }
      )
    }
  },
  updated() {}
}
</script>
